"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = _styledComponents.default.select.withConfig({
  displayName: "Select",
  componentId: "sc-1lkyg9e-0"
})(["height:calc(2em + 2px);padding:0.375em 1.5em 0.375em 0.75em;border:1px solid #6c757d;border-radius:0.25em;appearance:none;background-image:url('data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7');background-position:center right;background-repeat:no-repeat;font-size:1em;line-height:1.25;&:focus{outline:none;border-color:rgb(70,130,180);box-shadow:0 0 0 0.2em rgba(70,130,180,0.5);}"]);

exports.Select = Select;